@if (errors && errors.length > 0) {
    <div class="row">
        @for (level of errorLevels; track level) {
            @if (userMessagesByLevel[level].length > 0) {
                <div class="alert has-body is-error">
                    <span class="icon"><i class="tri-exclamation-circle" aria-hidden="true"></i></span>
                    <div class="body">
                        <div class="columns is-multiline">
                            @for (message of userMessagesByLevel[level]; track message) {
                                <div class="column is-12">
                                    <h5 class="text is-level-2">
                                        @if (!!message.message) {
                                            <span>{{ message.message }}</span>
                                        }
                                        @if (!message.message) {
                                            <span>
                                                Veuillez nous excuser, une erreur technique est survenue. Merci
                                                d'essayer à nouveau ultérieurement.
                                            </span>
                                        }
                                    </h5>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        }
    </div>
}
